export const manualInvoiceModal = {
  modalTitle: {
    create: "Utwórz fakturę ręcznie",
    correcting: "Popraw dane faktury",
  },
  confirm: {
    title: "Sprawdź przed utworzeniem",
    subtitle:
      "Zostanie utworzony szkic. Można go sprawdzić, dodać opłaty i wystawić w dowolnym momencie.",
    rowDocument: "Dokument",
    documentValue: "Szkic · numer przy wystawieniu",
    rowType: "Typ",
    typeCompany: "Firma / osoba prawna",
    typeIndividual: "Osoba fizyczna",
    labelCompanyName: "Nazwa firmy",
    labelName: "Imię i nazwisko",
    rowCountry: "Kraj",
    rowEmail: "E-mail",
    rowAddress: "Adres",
    rowPayment: "Płatność",
    rowNotes: "Uwagi",
  },
  info: {
    createTitle: "Zostanie utworzona faktura w stanie SZKIC (bez numeru do chwili wystawienia).",
    correctingTitle: "Poprawianie danych podatkowych",
    createBody:
      "Zostanie zapisana jako szkic. Można dodać opłaty, a gdy wszystko będzie gotowe, wystawić fakturę. Numer kolejny nadaje organ podatkowy w chwili wystawienia.",
    correctingBody:
      "Zmień tylko te dane, które wymagają korekty. Zostanie wygenerowana <strong>faktura korygująca</strong> z poprawnymi danymi.",
  },
  prefillLoading: "Wczytywanie danych podatkowych gościa…",
  // Facturar toda la reserva o una sola habitación (reservas de varias).
  scope: {
    lead: "Ta rezerwacja obejmuje kilka pokoi. Jaką fakturę chcesz utworzyć?",
    continue: "Dalej",
    label: "Jak chcesz fakturować?",
    whole: "Cała rezerwacja",
    wholeHint: "Jedna faktura obejmująca {n} pokoi.",
    perRoom: "Jeden pokój",
    perRoomHint: "Każdy pokój ma swoją fakturę: swoje noce i swoje opłaty.",
    pickRoom: "Wybierz pokój",
    repeatHint: "Powtórz dla każdego pokoju, aby każdy gość miał własną.",
  },

  recipientType: {
    label: "Typ odbiorcy",
    individual: "Osoba fizyczna",
    individualSub: "Osoba prywatna",
    company: "Firma",
    companySub: "Osoba prawna",
    active: "Aktywny",
  },
  // Buscador de clientes del fichero dentro del modal: evita teclear a mano
  // una empresa que ya está guardada.
  client: {
    label: "Zapisany klient",
    help: "Wyszukaj klienta z bazy, a jego dane podatkowe wypełnią się same. Jeśli go tam nie ma, wpisz dane ręcznie.",
    clear: "Usuń",
    linkedHint: "Dane pobrane z kartoteki klienta. Możesz poprawić dowolne pole bez utraty powiązania z klientem.",
    noFiscalProfile: "Ten klient nie ma zapisanego profilu rozliczeniowego: pobraliśmy imię i e-mail, resztę trzeba wpisać (albo uzupełnij jego kartotekę w Klientach).",
  },
  fields: {
    nameCompany: "Nazwa firmy *",
    nameIndividual: "Imię i nazwisko *",
    country: "Kraj",
    countryPlaceholder: "Wybierz kraj gościa",
    countryHint: "Podaj kraj rezydencji podatkowej gościa na potrzeby faktury.",
    optional: "(opcjonalnie)",
    emailLabel: "E-mail do faktur",
    phoneLabel: "Telefon",
    addressLabel: "Adres podatkowy",
    sectionInvoiceData: "Dane faktury",
    paymentSourceLabel: "Źródło płatności",
    paymentHintPrefilled:
      "Zaznaczone na podstawie zarejestrowanych płatności. Zmień, jeśli to nie jest poprawne.",
    paymentHintMulti:
      "Można zaznaczyć kilka pozycji, jeśli pobyt opłacono na więcej niż jeden sposób.",
    paymentHintNone: "Jeśli nic nie zostanie zaznaczone, faktura nie będzie zawierać informacji o sposobie zapłaty.",
    seriesLabel: "Seria",
    seriesHint: "Ta seria pochodzi z Twoich ustawień fakturowania.",
    notesLabel: "Dodatkowe dane faktury",
    notesHint:
      "Użyj tego pola, aby dodać dowolny opis, wyjaśnienia lub dodatkowe informacje o wystawieniu.",
  },
  preview: {
    label: "Następny numer kolejny",
    estHint: "orientacyjnie · nadawany przy wystawieniu (otrzyma go pierwsza wystawiona faktura)",
    noNumber: "Nadawany przy wystawieniu · szkic nie ma numeru",
  },
  footer: {
    cancel: "Anuluj",
    create: "Utwórz fakturę",
    editData: "Edytuj dane",
    creating: "Tworzenie...",
    createDraft: "Utwórz szkic",
  },
  success: {
    title: "Faktura wystawiona!",
    badge: "Wystawiona",
    pdfGenerating: "Trwa generowanie PDF. Może to potrwać kilka sekund.",
    downloadPdf: "Pobierz fakturę PDF",
    generatingPdf: "Generowanie PDF…",
    sendWhatsapp: "Wyślij przez WhatsApp",
    closeWindow: "Zamknij okno",
  },
  paymentSource: {
    cash: "Gotówka",
    card: "Karta kredytowa",
    transfer: "Przelew bankowy",
    otherOta: "Opłacone przez inną OTA",
  },
  prefill: {
    clientFile:
      "Dane pobrane z kartoteki klienta. Sprawdź je przed utworzeniem wersji roboczej.",
    invoiceRecipient: "Dane wczytane z ostatniej faktury gościa.",
    chat: "Dane podatkowe podane przez gościa przy prośbie o fakturę. Sprawdź je i wystaw fakturę.",
    checkin:
      "Wczytaliśmy imię, nazwisko i adres e-mail gościa z jego check-in. Uzupełnij poniżej jego dane podatkowe.",
    reservation:
      "Nie było kompletnych danych podatkowych, więc jako podstawę przyjęto podstawowe dane rezerwacji.",
    existingInvoice:
      "Dane wczytane z istniejącej faktury. Zmień to, co wymaga korekty.",
  },
  status: {
    sent: "Wystawiona",
    processing: "Przetwarzanie",
    pending: "Oczekuje",
    error: "Błąd",
  },
  toast: {
    whatsappSent: "Faktura wysłana przez WhatsApp.",
    whatsappError: "Nie udało się wysłać faktury przez WhatsApp.",
    draftCreated: "Szkic utworzony. Sprawdź go i wystaw, gdy będzie gotowy.",
  },
  validation: {
    nameRequired: "Imię i nazwisko lub nazwa firmy są wymagane.",
    countryInvalid: "Wybierz prawidłowy kraj.",
    emailInvalid: "Podaj prawidłowy adres e-mail.",
    taxIdRequired: "Ten numer identyfikacji podatkowej jest wymagany dla tego typu odbiorcy.",
  },
  errors: {
    conflict: "Ta rezerwacja ma już utworzoną fakturę.",
    checkData: "Sprawdź dane do faktury.",
    createFailed: "Nie udało się utworzyć faktury.",
  },
  taxId: {
    labels: {
      esCompany: "NIF firmy",
      brIndividual: "CPF lub RG",
      defaultIndividual: "Numer identyfikacji podatkowej",
      defaultCompany: "Numer podatkowy",
    },
    hints: {
      esIndividual: "DNI lub NIE (X1234567A). Paszport nie jest prawidłowym numerem podatkowym.",
      esCompany: "NIF/CIF firmy.",
      ptIndividual: "9 cyfr.",
      ptCompany: "9 cyfr.",
      coIndividual: "6-10 cyfr.",
      coCompany: "NIT z cyfrą kontrolną.",
      mxIndividual: "RFC osoby fizycznej.",
      mxCompany: "RFC osoby prawnej.",
      arIndividual: "11 cyfr z cyfrą kontrolną.",
      arCompany: "11 cyfr z cyfrą kontrolną.",
      clIndividual: "Z cyfrą kontrolną.",
      clCompany: "Z cyfrą kontrolną.",
      peIndividual: "8 cyfr.",
      peCompany: "11 cyfr.",
      ecIndividual: "10 cyfr.",
      ecCompany: "13 cyfr.",
      brIndividual:
        "Prawidłowy CPF do fakturowania. Jeśli wpiszesz RG, zostanie zapisany jako lokalny dokument gościa.",
      brCompany: "14 cyfr.",
      defaultIndividual: "Opcjonalnie.",
      defaultCompany: "Wymagane w przypadku firm.",
    },
  },
  address: {
    ES: { city: "Miasto", state: "Prowincja", zip: "Kod pocztowy" },
    PT: { city: "Miasto", state: "Dystrykt", zip: "Kod pocztowy" },
    CO: { city: "Miasto", state: "Dep.", zip: "Kod pocztowy" },
    MX: { city: "Miasto", state: "Stan", zip: "Kod pocztowy" },
    AR: { city: "Miasto", state: "Prowincja", zip: "Kod pocztowy" },
    CL: { city: "Miasto", state: "Region", zip: "Kod pocztowy" },
    BR: { city: "Miasto", state: "Stan", zip: "CEP" },
    US: { city: "Miasto", state: "Stan", zip: "ZIP" },
    GB: { city: "Miasto", state: "Hrabstwo", zip: "Kod pocztowy" },
    DEFAULT: { city: "Miasto", state: "Region", zip: "Kod pocztowy" },
  },
  taxErrors: {
    cifCompany: "Nieprawidłowy NIF/CIF firmy.",
    esIndividual: "Nieprawidłowy dokument. Podaj DNI, NIE (X1234567A) lub paszport.",
    ptNif: "Nieprawidłowy NIF. Musi mieć 9 prawidłowych cyfr.",
    nit: "Nieprawidłowy NIT.",
    coCedula: "Nieprawidłowa Cédula. Od 6 do 10 cyfr.",
    rfc: "Nieprawidłowy RFC.",
    cuit: "Nieprawidłowy CUIT.",
    cuilCuit: "Nieprawidłowy CUIL/CUIT.",
    rut: "Nieprawidłowy RUT.",
    ruc: "Nieprawidłowy RUC.",
    peDni: "Nieprawidłowy DNI. Musi mieć 8 cyfr.",
    ecCedula: "Nieprawidłowa Cédula.",
    cnpj: "Nieprawidłowy CNPJ.",
    brIndividual: "Nieprawidłowy dokument. Użyj prawidłowego CPF lub numeru RG w standardowym formacie.",
  },
};
